<template>
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">两面统计</span>
        </div>
      </div>
    </div>
    <loading v-if="isLoading" />
    <template v-else>
      <template v-if="liangMianStatsList">
        <div class="content-8__controlbar">
          <div class="content-8__controlbar__item">
            <div class="c8-explanation">
              <span class="c8-explanation__title">说明：</span>
              <div class="c8-explanation__content">
                <p>以每10期为一组，统计最近20组中单双大小的出现次数。</p>
              </div>
            </div>
          </div>
          <div class="content-8__controlbar__item">
            <div class="c8-select">
              <div class="c8-select__title">
                <span class="c8-select__title__text">筛选名次：</span>
              </div>
              <div class="c8-select__content">
                <a
                  v-for="btn in hmKeys"
                  :key="`btn-${btn.key}`"
                  :class="{'active': btn.key === selectKeys}"
                  class="button-outline c8-select__content__item"
                  @click="changeKey(btn)"
                >
                  <span class="button-outline__text">{{ btn.label }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="content-8__content">
          <table class="even-color">
            <thead>
              <tr>
                <th style="width: 400px;">日期</th>
                <th v-for="column in columnKeys" :key="column.key">{{ column.label }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rowData in liangMianStatsList" :key="`${rowData.start}-${rowData.end}`">
                <td>{{ `${rowData.date} ${rowData.end} - ${rowData.start}期` }}</td>
                <template v-for="column in columnKeys">
                  <td
                    :key="`tbody-${rowData.date}-${column.key}`"
                  >{{ rowData[selectKeys][column.key] }}</td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      <NoData v-else />
    </template>
  </div>
</template>

<script>
import { fieldList } from '@/utils/forWeb-Sean/liangMian'
import { getCPStatistics_web } from '@/api/desktop/statistic'
import * as moment from 'moment-mini'

import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
export default {
  name: 'WebLiangMianTongJi',
  components: {
    Loading,
    NoData
  },
  props: {
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      isLoading: true,
      lotteryCode: this.$route.params.lottery_code,
      liangMianStatsList: null,
      selectKeys: 'hm1'
    }
  },
  computed: {
    ...fieldList
  },
  created() {
    this.getLiangMianStatistics(this.lotteryCode)
  },
  methods: {
    async getLiangMianStatistics(code) {
      this.isLoading = true
      const [data, error] = await getCPStatistics_web(code, 'groupDXDS', {
        count: 20,
        rules: 'hmDanShuang,hmDaXiao'
      })
      if (error) return
      this.liangMianStatsList = data.map((each) => {
        const date = moment(each.date).format('MM月DD日')
        const start = each.start
        const end = each.end
        if (!each.list || each.list.length === 0) {
          const mapObject = this.hmKeys.reduce((returnObj, hm) => {
            returnObj[hm.key] = this.columnKeys.reduce((obj, col) => Object.assign(obj, { [col.key]: '-' }), {})
            return returnObj
          }, {})
          return Object.assign({}, { date, start, end, ...mapObject })
        } else {
          const mapObject = each.list.reduce((returnObj, listItem, listIndex) => {
            returnObj[`hm${listIndex + 1}`] = this.columnKeys.reduce((obj, col) =>
              Object.assign(obj, { [col.key]: Math.abs(listItem[col.key]) || 0 }), {})
            return returnObj
          }, {})
          return Object.assign({}, { date, start, end, ...mapObject })
        }
      })
      this.isLoading = false
    },
    changeKey(btn) {
      this.selectKeys = btn.key
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-active {
  background-color: red;
}
</style>
